import { p as prisma } from "./prisma.js";
function selectBestPromotion(basePrice, productId, categoryIds, activePromotions) {
  let best = null;
  let bestPriority = Number.POSITIVE_INFINITY;
  for (const promo of activePromotions) {
    const appliesToProduct = promo.products.some((p) => p.productId === productId);
    const appliesToCategory = !appliesToProduct && promo.categories.some((c) => categoryIds.includes(c.categoryId));
    if (!appliesToProduct && !appliesToCategory) continue;
    let finalPrice = basePrice;
    if (promo.discountType === "PERCENT") {
      finalPrice = Math.max(0, basePrice * (1 - promo.discountValue / 100));
    } else {
      finalPrice = Math.max(0, basePrice - promo.discountValue);
    }
    const discountAmount = basePrice - finalPrice;
    if (!best || finalPrice < best.finalUnitPrice - 1e-4 || Math.abs(finalPrice - best.finalUnitPrice) < 1e-4 && promo.priority < bestPriority) {
      best = {
        promotionId: promo.id,
        name: promo.name,
        discountType: promo.discountType,
        discountValue: promo.discountValue,
        unitPrice: basePrice,
        finalUnitPrice: Number(finalPrice.toFixed(2)),
        discountAmount: Number(discountAmount.toFixed(2))
      };
      bestPriority = promo.priority;
    }
  }
  return best;
}
function buildPromotionIndex(activePromotions) {
  const byProduct = /* @__PURE__ */ new Map();
  const byCategory = /* @__PURE__ */ new Map();
  for (const promo of activePromotions) {
    for (const { productId } of promo.products) {
      const arr = byProduct.get(productId);
      if (arr) arr.push(promo);
      else byProduct.set(productId, [promo]);
    }
    for (const { categoryId } of promo.categories) {
      const arr = byCategory.get(categoryId);
      if (arr) arr.push(promo);
      else byCategory.set(categoryId, [promo]);
    }
  }
  return { byProduct, byCategory };
}
function selectBestPromotionIndexed(basePrice, productId, categoryIds, index) {
  const candidateMap = /* @__PURE__ */ new Map();
  const direct = index.byProduct.get(productId) || [];
  for (const p of direct) candidateMap.set(p.id, p);
  for (const cid of categoryIds) {
    const arr = index.byCategory.get(cid) || [];
    for (const p of arr) {
      if (!candidateMap.has(p.id)) candidateMap.set(p.id, p);
    }
  }
  if (candidateMap.size === 0) return null;
  return selectBestPromotion(basePrice, productId, categoryIds, Array.from(candidateMap.values()));
}
async function getActivePromotions(now = /* @__PURE__ */ new Date(), opts) {
  const productIds = opts?.productIds?.filter((v, i, a) => a.indexOf(v) === i) || [];
  const categoryIds = opts?.categoryIds?.filter((v, i, a) => a.indexOf(v) === i) || [];
  const where = {
    isActive: true,
    startsAt: { lte: now },
    endsAt: { gte: now }
  };
  if (productIds.length || categoryIds.length) {
    const ors = [];
    if (productIds.length) ors.push({ products: { some: { productId: { in: productIds } } } });
    if (categoryIds.length) ors.push({ categories: { some: { categoryId: { in: categoryIds } } } });
    where.OR = ors;
  }
  return prisma.promotion.findMany({
    where,
    select: {
      id: true,
      name: true,
      discountType: true,
      discountValue: true,
      priority: true,
      products: { select: { productId: true } },
      categories: { select: { categoryId: true } }
    },
    orderBy: [{ priority: "asc" }, { startsAt: "desc" }]
  });
}
export {
  selectBestPromotionIndexed as a,
  buildPromotionIndex as b,
  getActivePromotions as g,
  selectBestPromotion as s
};
